/*
 * @Author: luohongbiao
 * @Date: 2022-01-05 09:51:49
 * @LastEditTime: 2022-07-22 22:35:01
 * @LastEditors: LHB
 * @Description:
 * @FilePath: \shirleyClass\src\main.js
 */
import Vue from 'vue'
import router from './router'
import App from './App.vue'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'
import 'amfe-flexible'
import './assets/styles/reset.css'
import utils from './utils/index'

Vue.config.productionTip = false
Vue.use(router)
Vue.prototype.$http = axios
Vue.use(VueClipboard)
import {
  Button,
  CountDown,
  Toast,
  Form,
  Field,
  Cascader,
  Popup,
  Area,
  Dialog,
  Overlay,
  Divider,
  Step,
  Steps,
  DatetimePicker,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Lazyload
} from 'vant'
const VantItem = [
  Button,
  CountDown,
  Toast,
  Form,
  Field,
  Cascader,
  Popup,
  Area,
  Dialog,
  Overlay,
  Divider,
  Step,
  Steps,
  DatetimePicker,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Lazyload
]
VantItem.forEach((item) => {
  Vue.use(item)
})

const vm = new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')

export default vm
